// API Endpoints configuration
export class ApiEndpoints {
  // Active endpoints in Drumly Core API v1
  static readonly HEALTH = "/health/";
  static readonly ADMIN_DASHBOARD = "/admin/dashboard";

  static readonly ANNOUNCEMENTS = "/announcements/";
  static readonly ADMIN_ANNOUNCEMENTS = "/admin/announcements/";

  static readonly SONGS = "/songs/";
  static readonly SONG_BY_ID = "/songs"; // + /{song_id}

  // Admin users
  static readonly ADMIN_USERS = "/admin/users";
  static readonly ADMIN_USER_BY_ID = "/admin/users"; // + /{user_id}
  static readonly ADMIN_USER_STATUS = "/admin/users"; // + /{user_id}/status
  static readonly ADMIN_USER_DEVICES = "/admin/users"; // + /{user_id}/devices
  static readonly ADMIN_USER_SONGS = "/admin/users"; // + /{user_id}/songs
  static readonly ADMIN_USER_NOTIFICATIONS = "/admin/users"; // + /{user_id}/notifications
  static readonly ADMIN_USER_ROLES = "/admin/users"; // + /{user_id}/roles

  // Admin song requests
  static readonly ADMIN_SONG_REQUESTS_V1 = "/admin/song-requests";
  static readonly ADMIN_SONG_REQUEST_BY_ID = "/admin/song-requests"; // + /{request_id}
  static readonly ADMIN_SONG_REQUEST_STATUS_V1 = "/admin/song-requests"; // + /{request_id}/status

  // Admin songs
  static readonly ADMIN_SONGS = "/admin/songs";
  static readonly ADMIN_SONG_BY_ID = "/admin/songs"; // + /{song_id}
  static readonly ADMIN_SONG_PUBLISH = "/admin/songs"; // + /{song_id}/publish

  // Admin notifications
  static readonly ADMIN_NOTIFICATIONS_SEND = "/admin/notifications/send";
  static readonly ADMIN_NOTIFICATIONS_SEND_SINGLE = "/admin/notifications/send-single";
  static readonly ADMIN_NOTIFICATIONS = "/admin/notifications";
  static readonly ADMIN_NOTIFICATIONS_BY_ID = "/admin/notifications"; // + /{notification_id}
  static readonly ADMIN_NOTIFICATION_CAMPAIGNS = "/admin/notifications/campaigns";

  static readonly USER_ME = "/users/me";
  static readonly USER_PROFILE = "/users/me";
  static readonly USER_DEVICES = "/users/me/devices";
  static readonly USER_DEVICE = "/users/me/devices"; // + /{device_id}
  static readonly USER_SONGS = "/users/me/songs";

  static readonly USER_NOTIFICATION_DEVICES = "/users/me/notification-devices";
  static readonly USER_NOTIFICATION_DEVICE = "/users/me/notification-devices"; // + /{device_id}

  static readonly USER_NOTIFICATIONS = "/users/me/notifications";
  static readonly USER_NOTIFICATIONS_READ_ALL = "/users/me/notifications/read-all";
  static readonly USER_NOTIFICATION_READ = "/users/me/notifications"; // + /{notification_id}/read
  static readonly USER_NOTIFICATION_BY_ID = "/users/me/notifications"; // + /{notification_id}

  // Deprecated endpoints kept for compatibility with hidden/legacy modules
  static readonly SONG_SEARCH = "/songs/search";
  static readonly MY_SONGS = "/songs/my-songs";
  static readonly ASSIGNED_SONGS = "/songs/assigned";
  static readonly SONG_SUGGESTIONS = "/songs/suggestions";
  static readonly MY_STATS = "/songs/my-stats";
  static readonly SONG_REQUESTS = "/song-requests";
  static readonly MY_SONG_REQUESTS = "/song-requests/my";
  static readonly ADMIN_SONG_REQUESTS = "/song-requests/admin/all";
  static readonly ADMIN_SONG_REQUEST_STATS = "/song-requests/admin/stats";
  static readonly ADMIN_SONG_REQUEST_STATUS = "/song-requests/admin";
  static readonly ADMIN_SONG_REQUEST_APPROVE = "/song-requests/admin";
  static readonly ADMIN_SONG_REQUEST_REJECT = "/song-requests/admin";
  static readonly BEATS = "/beats";
  static readonly USER_BASE = "/users";
  static readonly USER_ADMIN = "/users/admin";
  static readonly USERS_ALL = "/users/all";
  static readonly USER_FCM_TOKEN = "/users/me/fcm-token";
  static readonly USER_DEVICE_LEGACY = "/users/me/device";
  static readonly USER_ASSIGNED_SONG_LEGACY = "/users/me/assigned-song";
  static readonly USER_DEVICE_ADMIN = "/users";
  static readonly USER_ASSIGNED_SONG_ADMIN = "/users";
  static readonly SONG_TYPES = "/song-types";
  static readonly CONVERTER_GUITAR_PRO = "/converter/guitar-pro";
  static readonly CONVERTER_VALIDATE = "/converter/guitar-pro/validate";
  static readonly AUTH_LOGIN = "/auth/login";
  static readonly AUTH_LOGOUT = "/auth/logout";
  static readonly AUTH_VERIFY = "/auth/verify";
  static readonly ADMIN_SET_CLAIM = "/admin/set-admin-claim";
  static readonly ADMIN_REMOVE_CLAIM = "/admin/remove-admin-claim";
  static readonly ADMIN_CHECK = "/admin/check-admin";
  static readonly ADMIN_LIST = "/admin/list-admins";
} // API configuration
export const API_CONFIG = {
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
  retryAttempts: 3,
  retryDelay: 1000,
} as const;
